<template>
  <div class="image-uploader-cont">
    <image-uploader
      :id="`image-uploader-${id}`"
      :name="`image-uploader-${id}`"
      :debug="1"
      :maxWidth="600"
      :quality="1"
      :autoRotate="true"
      outputFormat="verbose"
      :preview="false"
      :capture="false"
      accept="video/*,image/*"
      doNotResize="['gif', 'svg']"
      @input="handleSelectFile"
      style="display: none"
    ></image-uploader>
    <label :for="`image-uploader-${id}`" class="w-full">
      <div class="image-cont">
        <image-reader
          :image="getImageSource"
          :class="childclass"
          style="width: 100%; height: 100%; border-radius: 10px"
        />
        <div class="upload-button">
          <feather-icon icon="UploadIcon" svgClasses="w-5 h-5"></feather-icon>
        </div>
      </div>
    </label>

    <vs-popup title="برش عکس" :active.sync="cropPopupVisible">
      <cropper
        v-if="imageBase64"
        :imageBase64="imageBase64"
        :cropPopupVisible="cropPopupVisible"
        :aspectRatio="aspectRatio"
        @cropImage="cropImage"
        :fileType="fileType"
      />
    </vs-popup>
  </div>
</template>

<script>
import ImageUploader from "vue-image-upload-resize";
import Cropper from "./Cropper.vue";

import placeholder from "../../assets/images/placeholder.jpg";

export default {
  name: "ImageCropperInput",
  components: { ImageUploader, Cropper },
  props: {
    id: {
      type: String,
      required: true,
    },
    childclass: {
      type: String,
      required: false,
    },
    image: {
      type: [Blob, Object],
      required: false,
    },
    aspectRatio: {
      type: Number,
      default: NaN,
    },
    fileName: {
      type: String,
    },
  },
  data() {
    return {
      imageSource: this.image,
      placeholder,
      fileType: null,
      imageBase64: null,
      cropPopupVisible: false,
    };
  },
  computed: {
    getImageSource() {
      return this.imageSource || { url: this.placeholder };
    },
  },
  methods: {
    handleSelectFile(output) {
      if (output) {
        this.cropPopupVisible = true;
        this.imageBase64 = output.dataUrl; // Base64
        this.fileType = output.info?.type;
      }
    },
    cropImage(blob) {
      if (this.id !== "image-0") {
        this.imageSource = blob;
      }
      this.$emit("input", blob);
      this.cropPopupVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.image-uploader-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .image-cont {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    border: 1px solid lightgray;
    border-radius: 10px;

    .upload-button {
      border-radius: 50%;
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: -12px;
      right: 5px;
      color: #232323;
      background-color: rgba($color: #ffffff, $alpha: 1);
      box-shadow: 0px 0px 6px 1px rgba(var(--vs-primary), 0.6);
    }
  }

  .cropper {
    max-height: 300px;
  }
}
</style>